export enum UserRole {
  Admin = 'Admin',
  Chargeur = 'Chargeur',
  Transporteur = 'Transporteur',
  Transporteur2 = 'Transporteur2',
  DLE='DLE'
}
